'use strict';

module.exports = ['$http', '$timeout',
    function ($http, $timeout) {

        let getIdDebounce;

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                model: '=',
                options: '=',
                pbreadonly: '=',
                details: '=',
                rmId: '@',
            },
            templateUrl: '/partial/app.directives.facebook',
            link: function (scope, element, attributes) {
                scope.showMore = false;
                if (!scope.model || typeof scope.model !== 'object') {
                    scope.model = {
                        name: '',
                        id: 0,
                        type: ''
                    };
                }

                function error(error, value = null) {
                    if (scope.form && scope.form[scope.name]) { //make sure there is an form
                        if (value == null) {
                            return scope.form[scope.name].$error[error];
                        } else {
                            scope.form[scope.name].$setValidity(error, value);
                        }
                    }
                }

                function sanitizeToName(name) {
                    if (name.match(/^.*facebook\.com/)) {
                        let matched = name.match(/^.*facebook\.com\/([a-z0-9.\-_]+)/i);
                        if (matched) {
                            return matched[1];
                        } else {
                            error('NoValidUrl', false);
                        }
                    } else {
                        return name;
                    }
                }

                scope.getId = () => {
                    if(getIdDebounce) {
                        $timeout.cancel(getIdDebounce);
                    }

                    getIdDebounce = $timeout(() => {
                        scope.loading = true;
                        if (!scope.model.name) {
                            scope.loading = false;
                            scope.messages = [];
                            scope.model.id = 0;
                            scope.model.type = '';
                            scope.form[scope.name].$setValidity('noUsername', true);
                            scope.form[scope.name].$setValidity('noAccounts', true);
                            return;
                        }
                        let name = sanitizeToName(scope.model.name);

                        $http.get('/social/facebook/getid/' + name).then((response) => {
                            if (error('NoValidUrl')) {
                                error('NoValidUrl', true);
                            }
                            if (error('noUsername')) {
                                error('noUsername', true);
                            }
                            if(error('noAccounts')) {
                                error('noAccounts', true);
                            }
                            if (response.data.status == 404) {
                                error('noUsername', false);
                                scope.header = {};
                                scope.model.type = '';
                                scope.model.id = 0;
                                scope.messages = [];
                            } else if (response.data.status == 400 && response.data.message == 'no_accounts') {
                                error('noAccounts', false);
                            } else if (response.data.status == 200) {
                                scope.header = response.data.headerData;

                                scope.model.type = response.data.type;
                                scope.model.id = response.data.headerData.id;

                                if (error('noUsername')) {
                                    error('noUsername', true);
                                }
                                if (error('noAccounts')) {
                                    error('noAccounts', true);
                                }
                            }
                            scope.loading = false;
                        });
                    }, 800)
                };

                $http.get('/social/user/').then((response) => {
                    if(response.data.facebook[0]) {
                        if (response.data.facebook[0].active == 0) {
                            scope.model = null;
                            scope.options.disabled = true;
                        }
                    } else {
                        scope.model = null;
                        scope.options.disabled = true;
                    }
                });

                scope.toggleMore = () => {
                    scope.showMore = !scope.showMore;
                };

                if(scope.model.id) {
                    $http.get('/social/facebook/' + scope.model.type + 'data/' + scope.model.id).then((response) => {
                        if (response.data.status == 404) {
                            error('noUsername', false);
                            scope.header = {};
                            scope.model.type = '';
                            scope.model.id = 0;
                            scope.messages = [];
                        } else if (response.data.status == 200) {
                            scope.header = response.data.headerData;
                            scope.messages = response.data.messagesData;

                            if (error('noUsername')) {
                                error('noUsername', true);
                            }
                        }
                        scope.loading = false;
                    });
                }

                scope.$watch('model', (newVal, oldVal) => {
                    if(typeof newVal == 'string') {
                        scope.model = oldVal;
                        scope.model.name = newVal;
                        scope.getId();
                    }

                })
            }
        };
    }
];

